import '@/assets/styles/pages/my-account/my-account.scss';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import '@/assets/styles/pages/trading-page.scss';
import {CashAccount , Instrument , Portfolio} from '@/configurations/components-configs/components.config';
import OrderBook from '@/companys/fubon/components/OrderTable/OrderBook';
import OrderHistory from '@/companys/fubon/components/OrderTable/OrderHistory';
import TabHeader from '@/components/TabHeader/TabHeader';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import { ctrlID } from '@/constants/ctr-id';
import { accountActions } from '@/actions/trading/account.actions';
import { PARAMS } from '@/constants/params';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { CUSTOM_STYLES } from '@/constants/app';
import { receiveMessage } from '@/assets/aastock_libs/postmessage';
import BlockControl from '@/components/BlockControl/BlockControl'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';

const ORDER_BOOK_TABLE = 3;
const ORDER_HISTORY_TABLE = 4;
const PORTFOLIO_TABLE = 2;

class Trade extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderTableTab: ORDER_BOOK_TABLE,
      orderTableTabList: [
        { id: 9, title: 'order_book_title', isActive: true },
        { id: 8, title: 'order_history_title' },
        { id: 7, title: 'portfolio_title', configID: ctrlID.accountCtrl }
      ],
      maximumDate: {},
      searchParams: {
        status: '',
        startDate: '',
        endDate: ''
      },
      aaStockUrl: '',
      load: true,
      aaStock: [{
        id: '1', title: 'market_info', isActive: false
      }],
    }
    this.enabledAccount = props.p_Identifier ? (props.p_Identifier.child.includes(ctrlID.accountCtrl)) : true;
  }

  render() {
    const { orderTableTab, orderTableTabList, maximumDate, load, aaStock } = this.state;
    return (
      <React.Fragment>
        <div className='trading-container'>
          <div className="left">
            <BlockControl name='trade-portfolio'>
              <section className={classNames(this.enabledAccount ? 'stock-table' : 'tow-colum')}>
                {this.enabledAccount ? <Portfolio /> :
                  <React.Fragment>
                    <div className="left-content">
                      <TabHeader tabs={aaStock} refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onRefresh={() => this.getAAStock()} />
                      <LoadingLayer load={load} />
                      <iframe id="TRADE" onLoad={() => { this.setState({ load: false }) }} className="customer-frame" src={this.state.aaStockUrl}></iframe>
                    </div>
                    <section className="right-content">
                      <Instrument p_Identifier={this.props.p_Identifier} />
                    </section>
                  </React.Fragment>}
              </section>
            </BlockControl>
            <BlockControl name='order-table'>
              <section className="order-table">
                <TabHeader
                  innerRef={e => this.tabHeaderOrderRef = e}
                  tabs={orderTableTabList}
                  onChange={this.handleChangeOrderTableTab}
                  orderFilterDropdown={orderTableTab !== PORTFOLIO_TABLE}
                  orderFilterRadio={ iTradeEnv?.pages?.trade?.ctrl?.orderFilter}
                  onSelectOrderFilter={this.handleFilter}
                  dateRangePicker={orderTableTab === ORDER_HISTORY_TABLE}
                  maximumDate={maximumDate}
                  onChangeDatePicker={this.handleChangeDatePicker}
                  refresh
                  onRefresh={this.handleSearchData}
                  marketFilter={orderTableTab === PORTFOLIO_TABLE}
                  onChangeMarket={this.handleChangeMarket}
                />
                {orderTableTab === ORDER_BOOK_TABLE && <OrderBook innerRef={e => this.orderBookRef = e} />}
                {orderTableTab === ORDER_HISTORY_TABLE && <OrderHistory innerRef={e => this.orderHistoryRef = e} />}
                {orderTableTab === PORTFOLIO_TABLE && <Portfolio tabHeader={false} innerRef={e => this.portfolioRef = e} />}
              </section>
            </BlockControl>
          </div>
          <BlockControl name='right-view'>
            {
              this.enabledAccount &&
              <div className={classNames('right' , `right-${iTradeEnv.company}`)} style={{ width: BlockControl.isBlockAction('right-view-style', false, '100%') }}>
                <BlockControl name='asset'>
                  <section className="asset" style={{ height: BlockControl.isBlockAction('asset-style', false, '100%') }}>
                    <CashAccount />
                  </section>
                </BlockControl>
                <BlockControl name='place-order'>
                   <section className="stock-infor">
                   <Instrument p_Identifier={this.props.p_Identifier} TradeDashboard={true} /> 
                    </section>
                </BlockControl>
              </div>
            }
          </BlockControl>
        </div>
      </React.Fragment>
    )
  }

  handleChangeMarket = (market) => {
    if (market) {
      this.portfolioRef.handleChangeMarket(market)
    }
  }

  handleChangeDatePicker = (date) => {
    const startDate = this.convertDateObjectToString(date.from);
    const endDate = this.convertDateObjectToString(date.to);
    const { searchParams } = this.state;
    if (startDate !== searchParams.startDate || endDate !== searchParams.endDate) {
      this.setState({
        searchParams: Object.assign({}, searchParams,
          {
            startDate,
            endDate
          })
      }, () => this.handleSearchData())
    }
  }

  handleFilter = (key) => {
    const { searchParams } = this.state;
    switch (key) {
      case 'all': {
        this.setState({ searchParams: Object.assign({}, searchParams, { status: '' }) }, () => {
          this.handleSearchData();
        })
        break;
      }
      default: {
        this.setState({ searchParams: Object.assign({}, searchParams, { status: key.toUpperCase() }) }, () => {
          this.handleSearchData();
        })
        break;
      }
    }
  }

  handleSearchData = () => {
    const { orderTableTab, searchParams } = this.state;
    const { status, startDate, endDate } = searchParams;

    let tableRef = null;
    if (orderTableTab === ORDER_BOOK_TABLE) {
      tableRef = this.orderBookRef;
    } else if (orderTableTab === ORDER_HISTORY_TABLE) {
      tableRef = this.orderHistoryRef;
    } else if (orderTableTab === PORTFOLIO_TABLE) {
      this.portfolioRef.getPortfolio()
    }
    if (tableRef) {
      if(orderTableTab === ORDER_BOOK_TABLE){
        tableRef.getData(status, true)
      }else{
        tableRef.getData(status, startDate, endDate)
      }
    }
  }

  handleChangeOrderTableTab = (tab) => {
    switch (tab.main.title) {
      case 'order_book_title': {
        this.setState({
          orderTableTab: ORDER_BOOK_TABLE,
          searchParams: {
            status: '',
            startDate: '',
            endDate: ''
          }
        })
        break;
      }
      case 'order_history_title': {
        const maximumDate = this.getMaximumDate();
        this.setState({
          orderTableTab: ORDER_HISTORY_TABLE,
          searchParams: {
            status: '',
            startDate: this.convertDateObjectToString(maximumDate),
            endDate: this.convertDateObjectToString(maximumDate)
          }
        }, () => {
          this.tabHeaderOrderRef.setDatePickerValue(maximumDate);
        })
        break;
      }
      case 'portfolio_title': {
        this.setState({
          orderTableTab: PORTFOLIO_TABLE,
        })
        break;
      }
      default: break;
    }
  }

  convertDateObjectToString(date) {
    return `${date.year}-${date.month}-${date.day}`
  }

  getMaximumDate() {
    let date = new Date();
    date.setDate(date.getDate() - 1); // get yesterday
    const maximumDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    }
    this.setState({ maximumDate })
    return maximumDate;
  }

  UNSAFE_componentWillMount() {
    BlockControl.initEmbeddedTable.bind(this)('orderTableTabList')
  }

  componentDidMount() {
    this.getMaximumDate();
    this.initConfigTableHeader()
    this.getAAStock()
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.handleSearchData();
      this.getAAStock()
    }
    if (this.props.isNeedRefresh && this.props.isNeedRefresh !== prevProps.isNeedRefresh) {
      this.handleSearchData()
    }
    if (prevProps.language !== this.props.language) {
      this.handleSearchData()
      this.getAAStock()
    }
    if (this.props.token && this.props.token !== prevProps.token ) {
      this.getAAStock()
    }
  }

  getAAStock() {
    const { language, currentTradingAccount, token } = this.props;
    if (currentTradingAccount.clientID && token) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.setState({
        load: true
      })
      this.props.getAAStock(params, res => {
        if (res.result.marketInfo.length > 0) {
          this.setState({
            aaStockUrl: res.result.marketInfo[0].url
          }, () => {
            receiveMessage((e) => {
              var str = e.data;
              var res = str.split("&");

              var lvStock = "";
              var lvBuySell = "";
              var lvPrice = "";
              for (var i = 0; i < res.length; i++) {
                var lvTempValue = "";
                var lvRes = res[i].split("=");
                var lvResTemp = lvRes[0];
                var lvResTemp1 = lvRes[1];

                if (lvResTemp.indexOf("stock") >= 0) {
                  lvStock = lvResTemp1;
                }
                if (lvResTemp.indexOf("buySell") >= 0) {
                  lvBuySell = lvResTemp1;
                }
                if (lvResTemp.indexOf("price") >= 0) {
                  lvPrice = lvResTemp1;
                }
              }
              window.top.mainFrame.OrderFrame.setStockCode(lvStock);
              window.top.mainFrame.OrderFrame.setPrice(lvPrice);
            }, this.state.aaStockUrl)
          })
        } else {
          this.setState({
            load: false
          })
        }
      })
    }
  }

  initConfigTableHeader() {
    let arr = []
    this.state.orderTableTabList.map(item => {
      if (item.configID) {
        if (this.props.p_Identifier.child.includes(item.configID)) {
        } else {
          return arr.push(item)
        }
      } else {
        return arr.push(item);
      }

    })
    this.setState({
      orderTableTabList: arr
    })
  }


  initConfigTableHeader() {
    let arr = []
    this.state.orderTableTabList.map(item => {
      if (item.configID) {
        if (this.props.p_Identifier.child.includes(item.configID)) {
        } else {
          return arr.push(item)
        }
      } else {
        return arr.push(item);
      }

    })
    this.setState({
      orderTableTabList: arr
    })
  }
}

Trade.defaultProps = {
  p_Identifier: appEnvironment.custom_ctr_configs.tradeCtrl
}

export default connect(
  state => ({
    mode: state.app.mode,
    currentTradingAccount: state.trade.currentTradingAccount,
    isNeedRefresh: state.refresh.orderTable,
    language: state.app.language,
    token: state.auth.token
  }),
  dispatch => ({
    getAAStock: (p, res) => dispatch(accountActions.getAAStockAction(p, res))
  })
)(Trade)
